export enum Permissions {
  // Documents
  Documents_Read = "Documents_Read",
  Documents_Write = "Documents_Write",
  // Document Configuration
  DocumentConfigurations_Read = "DocumentConfigurations_Read",
  DocumentConfigurations_Write = "DocumentConfigurations_Write",
  // Document Custom View
  DocumentCustomView_Read = "DocumentCustomView_Read",
  DocumentCustomView_Write = "DocumentCustomView_Write",
  
  UserManagement_Read = "UserManagement_Read",
  UserManagement_Write = "UserManagement_Write",
  UserManagement_ManageCompany = "UserManagement_ManageCompany",
  Company_Read = "Company_Read",
  Company_Write = "Company_Write",
  WorkflowManagement_Write = "WorkflowManagement_Write",
  WorkflowManagement_Read = "WorkflowManagement_Read",
  WorkflowTemplateTask_View = "WorkflowTemplateTask_View",
  WorkflowTemplateTask_ViewAll = "WorkflowTemplateTask_ViewAll",
  WorkflowTemplate_View= "WorkflowTemplate_View",
  WorkflowTemplate_Update="WorkflowTemplate_Update",
  WorkflowTemplate_Deactivate="WorkflowTemplate_Deactivate",
  Suppliers_Read = "Suppliers_Read",
  Suppliers_Write = "Suppliers_Write",

  // Manual Document
  ManualDocumentsIN_Write = "ManualDocumentsIN_Write",
  ManualDocumentsPO_Write = "ManualDocumentsPO_Write",
  ManualDocumentsDN_Write = "ManualDocumentsDN_Write",
  ManualDocumentsSeries_Read = "ManualDocumentsSeries_Read",
  ManualDocumentsSeries_Write = "ManualDocumentsSeries_Write",

  Dashboard_Read = "Dashboard_Read",

  Catalog_Dimensions_View = "Catalog_Dimensions_View",
  Catalog_Dimensions_Create = "Catalog_Dimensions_Create",
  Catalog_Dimensions_Update = "Catalog_Dimensions_Update",
  Catalog_Dimensions_Delete = "Catalog_Dimensions_Delete",

  Catalog_DimensionValues_View = "Catalog_DimensionValues_View",
  Catalog_DimensionValues_Create = "Catalog_DimensionValues_Create",
  Catalog_DimensionValues_Update = "Catalog_DimensionValues_Update",
  Catalog_DimensionValues_Delete = "Catalog_DimensionValues_Delete",

  Catalog_Currencies_View = "Catalog_Currencies_View",
  Catalog_Currencies_Create = "Catalog_Currencies_Create",
  Catalog_Currencies_Update = "Catalog_Currencies_Update",
  Catalog_Currencies_Delete = "Catalog_Currencies_Delete",

  Catalog_PaymentTerms_View = "Catalog_PaymentTerms_View",
  Catalog_PaymentTerms_Create = "Catalog_PaymentTerms_Create",
  Catalog_PaymentTerms_Update = "Catalog_PaymentTerms_Update",
  Catalog_PaymentTerms_Delete = "Catalog_PaymentTerms_Delete",

  Catalog_PaymentMethods_View = "Catalog_PaymentMethods_View",
  Catalog_PaymentMethods_Create = "Catalog_PaymentMethods_Create",
  Catalog_PaymentMethods_Update = "Catalog_PaymentMethods_Update",
  Catalog_PaymentMethods_Delete = "Catalog_PaymentMethods_Delete",

  // Account Payable
  AP_CodingTemplate_View = "AP_CODINGTEMPLATE_VIEW",
  AP_CodingTemplate_Create = "AP_CODINGTEMPLATE_CREATE",
  AP_CodingTemplate_Update = "AP_CODINGTEMPLATE_UPDATE",
  AP_CodingTemplate_Delete = "AP_CODINGTEMPLATE_DELETE",
  AP_INVOICE_UPDATECODING = "AP_INVOICE_UPDATECODING",

  AP_INVOICE_VIEWCODING = "AP_INVOICE_VIEWCODING",

  AP_INVOICE_ACK = "AP_INVOICE_ACK",
  AP_INVOICE_VIEW = "AP_INVOICE_VIEW",
  AP_INVOICE_UPDATE = "AP_INVOICE_UPDATE",
  AP_DELIVERYNOTE_VIEW = "AP_DELIVERYNOTE_VIEW",
  AP_DELIVERYNOTE_UPDATE = "AP_DELIVERYNOTE_UPDATE",

  // Account Receivable
  AR_INVOICE_VIEW = "AR_INVOICE_VIEW",
  AR_INVOICE_UPDATE = "AR_INVOICE_UPDATE",
  AR_ORDER_VIEW = "AR_ORDER_VIEW",
  AR_ORDER_UPDATE = "AR_ORDER_UPDATE",
  AR_DELIVERYNOTE_VIEW = "AR_DELIVERYNOTE_VIEW",
  AR_DELIVERYNOTE_UPDATE = "AR_DELIVERYNOTE_UPDATE",

  AP_PostingDatePolicy_View = "AP_POSTINGDATEPOLICY_VIEW",
  AP_PostingDatePolicy_Create = "AP_POSTINGDATEPOLICY_CREATE",
  AP_PostingDatePolicy_Update = "AP_POSTINGDATEPOLICY_UPDATE",
  AP_PostingDatePolicy_Delete = "AP_POSTINGDATEPOLICY_DELETE",

  // Procurement Purchase Requisition
  Procurement_PurchaseRequisition_Create = "Procurement_PurchaseRequisition_Create",
  Procurement_PurchaseRequisition_Update = "Procurement_PurchaseRequisition_Update",
  Procurement_PurchaseRequisition_View = "Procurement_PurchaseRequisition_View",
  Procurement_PurchaseRequisition_Delete = "Procurement_PurchaseRequisition_Delete",
  Procurement_PurchaseRequisition_Post = "Procurement_PurchaseRequisition_Post",
  Procurement_PurchaseRequisition_Discard = "Procurement_PurchaseRequisition_Discard",
 
  // Procurement Purchase Order
  Procurement_PurchaseOrder_Create = "Procurement_PurchaseOrder_Create",
  Procurement_PurchaseOrder_Update = "Procurement_PurchaseOrder_Update",
  Procurement_PurchaseOrder_View = "Procurement_PurchaseOrder_View",
  Procurement_PurchaseOrder_Delete = "Procurement_PurchaseOrder_Delete",
  Procurement_PurchaseOrder_Post = "Procurement_PurchaseOrder_Post",
  
  // Procurement Goods Received Note
  Procurement_GoodsReceivedNote_Create = "Procurement_GoodsReceivedNote_Create",
  Procurement_GoodsReceivedNote_Update = "Procurement_GoodsReceivedNote_Update",
  Procurement_GoodsReceivedNote_View = "Procurement_GoodsReceivedNote_View",
  Procurement_GoodsReceivedNote_Discard = "Procurement_GoodsReceivedNote_Discard",
  Procurement_GoodsReceivedNote_Post = "Procurement_GoodsReceivedNote_Post",

  // User Role
  UserRole_Stage_View = "UserRole_Stage_View",
  UserRole_Stage_Manage = "UserRole_Stage_Manage",

  Supplier_OnboardingTemplate_View = "SUPPLIER_OBTEMPLATE_VIEW",
  Supplier_OnboardingTemplate_Create = "SUPPLIER_OBTEMPLATE_CREATE",
  Supplier_OnboardingTemplate_Update = "SUPPLIER_OBTEMPLATE_UPDATE",
  Supplier_OnboardingTemplate_Delete = "SUPPLIER_OBTEMPLATE_DELETE",

  //Peppol Party Registration
  PeppolPartyConfigurations_View = "PeppolPartyConfigurations_View",
  PeppolPartyConfigurations_Create = "PeppolPartyConfigurations_Create",
  PeppolPartyConfigurations_Unregister = "PeppolPartyConfigurations_Unregister",
}

